import React from 'react';
import './Certificate.css';
import StatsCard from '../popupsright/StatsCard';
import GetProCard from '../rightelements/GetProCard';
import FooterElements from '../rightelements/FooterElements';
import SocialElements from '../rightelements/SocialElements';
import CerificateButton from '../rightelements/CerificateButton';
import './reglaredimensiune.css';

export default function Certificate() {
  return (


    <div className="componentsmenu-container-main">

      <div className="componentsmenu-left-blank"></div>
      <div className="componentsmenu-container">

        <StatsCard />
        <div className="certificate-card">

          <div className="certificate-title">
            Certificare ContaLearn
          </div>

          <div className="certificate-description">
            La finalizarea cursului vei primi un certificat digital care confirma
            cunostintele dobandite si progresul tau profesional.
          </div>

          <div className="certificate-empty">
            Nu ai obtinut niciun certificat momentan.
            <br />
            Finalizeaza un curs pentru a debloca primul tau certificat digital.
          </div>

        </div>
      </div>
      <div className="right-elements-componentsmenu">
       <GetProCard />
       <CerificateButton />
        <FooterElements />
      <SocialElements />
      </div>

    </div>
  );
}
